import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e1b49ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "truncate"
}

import { computed, ref } from "vue";
import { snackbar } from "./TheSnackbar";

interface Props {
  /** text to show */
  text?: string;
  /** icon to show */
  icon?: string;
  /** location to link to */
  to?: string;
  /** on click action */
  click?: () => unknown;
  /** visual design */
  design?: "normal" | "circle" | "small";
  /** color */
  color?: "primary" | "secondary" | "none";
  /** whether to copy text prop to clipboard on click */
  copy?: boolean;
  /** html button type attribute */
  type?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppButton',
  props: {
    text: { default: "" },
    icon: { default: "" },
    to: { default: "" },
    click: { type: Function, default: undefined },
    design: { default: "normal" },
    color: { default: "primary" },
    copy: { type: Boolean, default: false },
    type: { default: "button" }
  },
  setup(__props: any, { expose }) {

const props = __props as { text: string, icon: string, to: string, click: () => unknown, design: "normal" | "circle" | "small", color: "primary" | "secondary" | "none", copy: boolean, type: string }



/** element ref */
const button = ref();

/** copy text prop to clipboard */
async function copyToClipboard() {
  await window.navigator.clipboard.writeText(props.text || "");
  snackbar("Text copied");
}

/** type of component to render */
const component = computed(() => (props.to ? "AppLink" : "button"));

/** allow parent to access ref */
expose({ button });

return (_ctx: any,_cache: any) => {
  const _component_AppIcon = _resolveComponent("AppIcon")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component)), {
    ref_key: "button",
    ref: button,
    class: "button",
    to: __props.to,
    type: __props.type,
    "data-design": __props.design,
    "data-color": __props.color,
    "data-text": !!__props.text,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.copy ? copyToClipboard() : __props.click))
  }, {
    default: _withCtx(() => [
      (__props.text)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.text), 1))
        : _createCommentVNode("", true),
      (__props.icon)
        ? (_openBlock(), _createBlock(_component_AppIcon, {
            key: 1,
            icon: __props.icon
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["to", "type", "data-design", "data-color", "data-text"]))
}
}

})